if ("IntersectionObserver" in window || !!window.IntersectionObserver) {
	const el = document.querySelector(".site-header-primary");
	const observer = new IntersectionObserver(
		function (entries, observer) {
			let entry = entries[0];
			if (entry.intersectionRatio < 1) {
				document.documentElement.setAttribute("data-menu-sticky", "true");
			} else {
				document.documentElement.setAttribute("data-menu-sticky", "false");
			}
		},
		{
			threshold: [1],
		}
	);

	observer.observe(el);
}
